module.exports = __webpack_public_path__ + "img/logo-mobile.289f9521.svg";